import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "../views/NotFound.vue";
// import Preview from "../views/Preview.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/all-home-version/Main.vue"),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/all-home-version/Home.vue'),
        meta: {
          pageTitle: 'Dashboard',
          breadcrumb: [
            {
              text: 'Dashboard',
              active: true,
            },
          ],
        },
      },
      // {
      //   path: '/inventory',
      //   name: 'home',
      //   component: () => import('../views/all-home-version/Inventory.vue'),
      //   meta: {
      //     pageTitle: 'Dashboard',
      //     breadcrumb: [
      //       {
      //         text: 'Dashboard',
      //         active: true,
      //       },
      //     ],
      //   },
      // },
    ]
  },
  {
    path: "/email",
    name: 'Email',
    meta: {
      title: "Email",
    },
    component: () => import("../views/Email.vue"),
  },
  {
    path: "*",
    name: NotFound,
    meta: {
      title: "404",
    },
    component: () => import("../views/NotFound.vue"),
  },
];
const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(savedPosition) {
    if (savedPosition.hash) {
      return {
        selector: savedPosition.hash
      }
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.afterEach((to) => {
  if (to.meta && to.meta.title) {
    document.title =
      to.meta.title + " | Shane - VueJS Personal Portfolio Template";
  }
});

export default router;
